/* Mobile recommendation navigation uses the existing scroll container. */
(() => {
 const compact=matchMedia('(max-width:749.98px)'),motion=matchMedia('(prefers-reduced-motion:reduce)');
 const selector='[id^="RelatedProducts--"] grid-slider';
 function update(){
  document.querySelectorAll(selector).forEach(slider=>{
   const button=slider.querySelector('.vnk-mobile-related-next'),track=slider.querySelector('[data-grid-slider]');
   if(!button||!track||!compact.matches)return;
   const image=track.querySelector('.product-item__image');
   if(image)slider.style.setProperty('--vnk-next-top',`${image.offsetTop+image.getBoundingClientRect().height/2}px`);
   button.disabled=track.scrollWidth-track.clientWidth-Math.abs(track.scrollLeft)<3;
  });
 }
 document.addEventListener('click',event=>{
  const button=event.target.closest('.vnk-mobile-related-next');
  if(!button||!compact.matches)return;
  const track=button.closest('grid-slider')?.querySelector('[data-grid-slider]');
  const cards=track?.querySelectorAll('.product-item');
  if(!cards?.length)return;
  const step=cards.length>1?Math.abs(cards[1].offsetLeft-cards[0].offsetLeft):cards[0].getBoundingClientRect().width;
  track.scrollBy({left:step*(getComputedStyle(track).direction==='rtl'?-1:1),behavior:motion.matches?'instant':'smooth'});
 });
 let queued=false;function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;update()})}
 document.addEventListener('scroll',schedule,{capture:true,passive:true});
 window.addEventListener('resize',schedule,{passive:true});compact.addEventListener('change',schedule);
 function init(){document.querySelectorAll('[id^="RelatedProducts--"]').forEach(section=>{new MutationObserver(schedule).observe(section,{childList:true,subtree:true});section.addEventListener('click',schedule);});update()}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
